export const EMPTY_FUNC = () => null;
